"use client";

import { extensionsWithLink, useEditor } from "@medimo/shared-editor";
import { useEffect } from "react";

export const NOTIFICATION_BANNER_TEXT_MAX_LENGTH = 120;

// お知らせ本文はリッチテキスト(tiptap)で保存されているため、バナーに出す際は
// プレーンテキストへ変換した上で文字数を数える。変換方法は既存の dialog.tsx と
// 同じ手順(非表示の editor に setContent し getText で取り出す)に揃えている
export const useNotificationBannerText = (body: string): string => {
  const editor = useEditor({
    editable: false,
    extensions: extensionsWithLink,
    immediatelyRender: false,
    content: "",
  });

  useEffect(() => {
    editor?.commands.setContent(body);
  }, [editor, body]);

  const plainText = (editor?.getText() ?? "").replace(/\s+/g, " ").trim();
  if (plainText.length <= NOTIFICATION_BANNER_TEXT_MAX_LENGTH) return plainText;
  return `${plainText.slice(0, NOTIFICATION_BANNER_TEXT_MAX_LENGTH)}…`;
};
